export default class UIUtil {

    constructor() {
        this.injectedFonts = {}
        this.previewedFonts = {}
    }

    usedFonts() {
        return Object.keys(this.injectedFonts)
    }

    injectCss(theme_path) {
        this.removeThemeLink("webase-theme")
        let url = `/api/v1/${theme_path}.css?t=${Date.now()}`
        let link = document.createElement("link");
        link.id = 'webase-theme'
        link.href = url;
        link.rel = "stylesheet";
        let newElement = document.getElementsByTagName("head")[0].appendChild(link);
        console.log(newElement)
    }

    getTailwindCss() {
        let styleElements = document.getElementsByTagName("style");

        for(let i = 0; i < styleElements.length; i++) {
            let styleElement = styleElements[i]
            if(styleElement.textContent.indexOf('tailwindcss') > 0) {
                return styleElement.textContent
            }
        }

        return ''
    }

    injectTempCss(theme_path) {
        this.removeThemeLink("webase-temp-theme")
        let url = `/api/v1/${theme_path}.css?temp=1&t=${Date.now()}`
        let link = document.createElement("link");
        link.id = 'webase-temp-theme'
        link.href = url;
        link.rel = "stylesheet";
        let newElement = document.getElementsByTagName("head")[0].appendChild(link);
        console.log(newElement)
    }

    removeThemeLink(themeId) {
        const element = document.getElementById(themeId);

        if (element) {
            element.remove();
        }
    }

    availableWeights(fontList, fontFamily) {
        for (let i = 0; i < fontList.length; i++) {
            let font = fontList[i]

            if (font.family === fontFamily) {
                return font.variants.filter(variant => variant.indexOf('italic') < 0)
            }
        }

        return []
    }

    injectFont(fontFamily, weights) {

        if (!weights) {
            weights = ':wght@400'
        }

        if (!this.injectedFonts[fontFamily]) {
            this.injectedFonts[fontFamily] = true
            let url = 'https://fonts.googleapis.com/css2?family=' + fontFamily + weights
            let link = document.createElement("link");
            link.href = url;
            link.rel = "stylesheet";
            document.getElementsByTagName("head")[0].appendChild(link);
        }
    }

    injectFontPreview(fontFamily, weights) {

        if (!weights) {
            weights = ':wght@400'
        }

        if (!this.previewedFonts[fontFamily]) {
            this.previewedFonts[fontFamily] = true
            let url = 'https://fonts.googleapis.com/css2?family=' + fontFamily + weights
            let link = document.createElement("link");
            link.href = url;
            link.rel = "stylesheet";
            document.getElementsByTagName("head")[0].appendChild(link);
        }
    }

    injectFontAndWeights(font) {
        // font is already loaded!
        if(this.injectedFonts[font.family]) {
            return
        }

        let weights = this.availableWeights(webase.model.fonts, font.family).join(';')
        weights = weights.replace('regular', '400')
        this.injectFont(font.family, ':wght@' + weights)
    }

    getClass(field) {
        if (field.field_type === 'Number') {
            return 'fa-hashtag'
        }

        if (field.field_type === 'Text') {
            return 'fa-file-alt'
        }

        if (field.field_type === 'Attachment') {
            return 'fa-paperclip'
        }

        if (field.field_type === 'URL') {
            return 'fa-link'
        }

        if (field.field_type === 'Single Select') {
            return 'fa-list'
        }

        if (field.field_type === 'Link to Object') {
            return 'fa-network-wired'
        }

        if (field.field_type === 'Date') {
            return 'fa-calendar'
        }

        if (field.field_type === 'Boolean') {
            return 'fa-toggle-on'
        }

        if (field.field_type === 'Collaborator') {
            return 'fa-user'
        }

        if (field.field_type === 'Image') {
            return 'fa-image'
        }

        // '', 'String', 'Text', 'Number', 'Boolean', 'Date', 'Single Select', 'Link to Object', 'Collaborator',
        //    'URL', 'Attachment', 'Dynamic'

        return 'fa-font'
    }

    getComponentClass(componentType) {
        if (componentType === 'Header') {
            return 'fal fa-heading'
        } else if (componentType === 'Icon') {
            return 'fad fa-icons'
        } else if (componentType === 'Link') {
            return 'fad fa-link'
        } else if (componentType === 'Button') {
            return 'fad fa-rectangle-landscape'
        } else if (componentType === 'Image') {
            return 'fad fa-image'
        } else if (componentType.indexOf('Container') > -1) {
            return 'fad fa-square'
        }

        return 'fa fa-font'
    }

    getJustifyClassRow(justifyValue) {
        if (justifyValue === 'left') {
            return 'justify-content-start'
        } else if (justifyValue === 'center') {
            return 'justify-content-center'
        } else if (justifyValue === 'right') {
            return 'justify-content-end'
        } else {
            return 'justify-content-between'
        }
    }

    getAlignClassRow(alignValue) {
        if (alignValue === 'top') {
            return 'align-items-start'
        } else if (alignValue === 'middle') {
            return 'align-items-center'
        } else {
            return 'align-items-end'
        }
    }

    getJustifyClassColumn(justifyValue) {
        if (justifyValue === 'left') {
            return this.getAlignClassRow('top')
        } else if (justifyValue === 'center') {
            return this.getAlignClassRow('middle')
        } else if (justifyValue === 'right') {
            return this.getAlignClassRow('bottom')
        } else {
            return ''
        }
    }

    getAlignClassColumn(alignValue) {
        if (alignValue === 'top') {
            return this.getJustifyClassRow('left')
        } else if (alignValue === 'middle') {
            return this.getJustifyClassRow('center')
        } else {
            return this.getJustifyClassRow('right')
        }
    }

    getIconTypeClass(iconType) {
        if (iconType === 'regular') {
            return 'far'
        } else if (iconType === 'brands') {
            return 'fab'
        } else {
            return 'fas'
        }
    }

    getMarginClass(margin) {
        if (margin.side === 'none') {
            return ''
        }

        return this.getSpacingPrefix(margin, 'm') + '-' + margin.value
    }

    getPaddingClass(padding) {
        if (padding.side === 'none') {
            return ''
        }

        return this.getSpacingPrefix(padding, 'p') + '-' + padding.value
    }

    getSpacingPrefix(margin, prefix) {
        if (margin.side === 'all') {
            return prefix
        } else if (margin.side === 'top/bottom') {
            return prefix + 'y'
        } else if (margin.side === 'left/right') {
            return prefix + 'x'
        } else if (margin.side === 'top') {
            return prefix + 't'
        } else if (margin.side === 'left') {
            return prefix + 's'
        } else if (margin.side === 'bottom') {
            return prefix + 'b'
        } else if (margin.side === 'right') {
            return prefix + 'e'
        } else {
            return ''
        }
    }

    isCustomColor(component) {
        return component.style && component.style.color && component.style.color.indexOf('#') === 0
    }

    isCustomBackgroundColor(component) {
        return component.style && component.style.backgroundColor && component.style.backgroundColor.indexOf('#') === 0
    }

    getOppositeColor(color) {
        return this.isLightOrDark(color) === 'light' ? 'dark' : 'light'
    }

    isLightOrDark(color) {
        // Variables for red, green, blue values
        var r, g, b, hsp;

        // Check the format of the color, HEX or RGB?
        if (color.match(/^rgb/)) {

            // If HEX --> store the red, green, blue values in separate variables
            color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

            r = color[1];
            g = color[2];
            b = color[3];
        } else {

            // If RGB --> Convert it to HEX: http://gist.github.com/983661
            color = +("0x" + color.slice(1).replace(
                color.length < 5 && /./g, '$&$&'));

            r = color >> 16;
            g = color >> 8 & 255;
            b = color & 255;
        }

        // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
        hsp = Math.sqrt(
            0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b)
        );

        return hsp > 127.5 ? 'light' : 'dark'
    }

    copyKeysPressed(event) {
        return this.checkKeyPress(event, 'KeyC', 'c', 67)
    }

    pasteKeysPressed(event) {
        return this.checkKeyPress(event, 'KeyV', 'v', 86)
    }

    checkKeyPress(event, code, key, keyCode) {
        if (event.code !== undefined && event.code === code && (event.metaKey || event.ctrlKey)) {
            return true
        } else if (event.key !== undefined && event.key === key && (event.metaKey || event.ctrlKey)) {
            return true
        } else if (event.keyCode !== undefined && event.keyCode === keyCode && (event.metaKey || event.ctrlKey)) {
            return true
        }

        return false
    }
}